
import { isEmpty } from "../gui_components/Util.js";
import {ServiceExecutorProxy}from "./ServiceExecutorProxy.js";
export class EntityLockService {
  constructor() {}
  static initService(appData) {
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    this.companyCode = appData.companyCode;
    this.entity_data_url =
      appData.serviceURL + `/${process.env.REACT_APP_EMTITYLOCK_SERVICE_PATH}`;
    localStorage.setItem("security_token", this.sessionBean.securityPass);
  }
  static getEntityLockList_v1(input, responseCallBack, errorCallBack) {
    this.method("getEntityLockList_v1", input, responseCallBack, errorCallBack);
  }

  static releaseLock(input, responseCallBack, errorCallBack) {
    this.method("releaseLock", input, responseCallBack, errorCallBack);
  }
  static releaseLockBasedOnLockType(input, responseCallBack, errorCallBack) {
    this.method(
      "releaseLockBasedOnLockType",
      input,
      responseCallBack,
      errorCallBack
    );
  }
  static method(methodName, input, responseCallBack, errorCallBack) {
    if (isEmpty(this.sessionBean)) {
    } else if (isEmpty(this.sessionBean.securityPass)) {
    } else {
      // const isFormData = input instanceof FormData;
      // axios({
      //   method: "post",
      //   url: this.entity_data_url + "/" + methodName,
      //   data: input,
      //   headers: {
      //     securitykey: localStorage.getItem("security_token"),
      //     Accept: "application/json",
      //     // "Content-Type": "application/json",
      //     ...(isFormData ? {} : { "Content-Type": "application/json" }),
      //   },
      // })
      //   .then((response) => {
      //     responseCallBack(response);
      //   })
      //   .catch((error) => {
      //     errorCallBack(error);
      //     ShowError("Erro : " + error);
      //   });
       ServiceExecutorProxy.executeService(methodName, input,this.entity_data_url,responseCallBack, errorCallBack);
    }
  }
}
